module.exports = __webpack_public_path__ + "static/media/34.07360730.mp3";